import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { AppPropertyBasicModel, CityModel, HxCityService } from 'hx-services';
import { CityEditComponent } from '@adm-web-app/modules/cities/edit/city-edit.component';
import { CityListComponent } from '@adm-web-app/modules/cities/list/city-list.component';
import { CityPropertyListComponent } from '@adm-web-app/modules/cities/properties/list/city-property-list.component';
import { CityPropertyEditComponent } from '@adm-web-app/modules/cities/properties/edit/city-property-edit.component';

const cityPropertyResolveFn: ResolveFn<AppPropertyBasicModel | undefined> = route => inject(HxCityService).getPropertyByKey(Number(route.paramMap.get('cityId')), String(route.paramMap.get('key')));

const cityResolveFn: ResolveFn<CityModel> = route => inject(HxCityService).getCityById(Number(route.paramMap.get('cityId')));

export const citiesRoutes: Routes = [
  {
    path: '', component: CityListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: CityEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':cityId/edit', component: CityEditComponent,
    resolve: {
      model: cityResolveFn
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
  {
    path: ':cityId/properties', component: CityPropertyListComponent,
    resolve: {
      model: cityResolveFn,
    },
    data: {
      breadcrumb: 'Properties'
    }
  },
  {
    path: ':cityId/properties/new', component: CityPropertyEditComponent,
    resolve: {
      model: cityResolveFn,
    },
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':cityId/properties/:key/edit', component: CityPropertyEditComponent,
    resolve: {
      model: cityResolveFn,
      property: cityPropertyResolveFn
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
